import React, {
  ReactElement,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
// import arrowRight from '@sg/assests/svg/arrow-right-white.svg';
import './index.scss';
import { Segment, Checkbox } from 'tea-component';
import OverallFinancials from './OverallFinancials';
import ExecutiveSummary from './ExecutiveSummay';
import NoAuthPage from '@sg/components/noAuthPage';
import { useIntl, useLocation, history } from 'umi';
import { getFormattedTabList } from '@sg/_config/permission';
import { usePermissionReady } from '@sg/hooks/usePermissionReady';
import {
  SGBuriedPoint,
  SGBuriedBtnPoint,
  BusinessManagementConfig,
  ExecutiveSummaryTab,
  OverallFinancialsTab,
  createBtnPoint,
  createPagePoint,
} from '@sg/utils/buriedPoint';
import { ICapsuleData } from '@sg/components/CapsuleBar/type.d';
import { BUSINESS_TEAM_CHECKBOX } from './config';
import { ITabListProp } from './type';

let checkbox: string[] = [];
export default function BusinessManagement(props: any) {
  const { formatMessage } = useIntl();
  const { activeSubTab, setActiveSubTab, pageId } = props;
  const { ready: permissionReady } = usePermissionReady();

  // Tab埋点 config mapping
  const TAB_CONFIGS = {
    executiveSummary: ExecutiveSummaryTab,
    overallFinancials: OverallFinancialsTab,
  };

  // Read activeSegment from URL instead of state
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const activeSegment = searchParams.get('subtitle') || activeSubTab || 'executiveSummary';
  const [forecastCheckbox, setForecastCheckbox] = useState<string[]>(checkbox);

  // Page埋点 - Track page view when sub-tab changes
  useEffect(() => {
    const tabConfig = TAB_CONFIGS[activeSegment as keyof typeof TAB_CONFIGS];
    if (tabConfig) {
      const pagePoint = createPagePoint(tabConfig);
      if (pagePoint) {
        SGBuriedPoint(pagePoint);
      }
    }
  }, [activeSegment]);
  const tabList = useMemo(() => {
    const options: ITabListProp[] = [
    {
      key: 'business_executiveSummary',
      text: formatMessage({ id: 'dbs_subtitle_executive_summary' }),
      value: 'executiveSummary',
      modules: (
        <ExecutiveSummary pageId={pageId} forecastCheckbox={forecastCheckbox} />
      ),
      trackingKey: 'tabClick', // Reference to ExecutiveSummaryTab.button
    },
    {
      key: 'business_overallFinancials',
      text: formatMessage({ id: 'dbs_subtitle_overall_financials' }),
      value: 'overallFinancials',
      modules: <OverallFinancials pageId={pageId} />,
      trackingKey: 'tabClick', // Reference to OverallFinancialsTab.button
    },
  ];
    return getFormattedTabList(options);
  }, [formatMessage, forecastCheckbox, pageId, permissionReady]);

  const executiveSummaryHasView = useMemo(
    () => tabList.find(item => item.value === 'executiveSummary')?.hasAuth,
    [tabList],
  );

  const handleActiveSegmentChange = (value: string) => {
    // Update URL using history.push to enable RoutePrompt interception
    const currentParams = new URLSearchParams(location.search);
    const params = new URLSearchParams();
    const tab = currentParams.get('tab');
    if (tab) {
      params.set('tab', tab);
    }
    params.set('subtitle', value);
    history.push(`/strategic/home?${params.toString()}`);
    
    // Still call setActiveSubTab for backward compatibility with parent
    setActiveSubTab(value);

    // Button埋点 - Track tab click
    const data = tabList.find((item) => item.value === value);
    if (data?.trackingKey) {
      const tabConfig = TAB_CONFIGS[value as keyof typeof TAB_CONFIGS];
      if (tabConfig) {
        const btnPoint = createBtnPoint(tabConfig, data.trackingKey, data.text);
        if (btnPoint) {
          SGBuriedBtnPoint(btnPoint);
        }
      }
    }
  };

  // const changeCapsualBusinessTeamItem = (
  //   arr: ICapsuleData[],
  //   value: string[] = [],
  // ) => {
  //   const newArr: any = [];
  //   const flag = value?.[0] !== 'businessTeamForecast';
  //   const findIndex = arr.findIndex(
  //     (item: ICapsuleData) => String(item?.title).endsWith('F - Business Team'),
  //   );
  //   if (findIndex !== -1) {
  //     arr.forEach((item: any, index) => {
  //       if (index !== findIndex) {
  //         newArr.push(item);
  //       }
  //     });
  //     newArr.push({
  //       ...arr[findIndex],
  //       isHide: flag,
  //     });
  //     return newArr;
  //   }
  //   return arr;
  // };

  const handleForecastCheckboxChange = (value: string[] = []) => {
    setForecastCheckbox(value);
    // 这个全局变量是为了记录页面间的状态，主要是切换后胶囊图会变化，因暂时是假数据，所以先写个全局变量替代，后续开发需要修改
    checkbox = value;
    // const changeList = [BUSINESS_GROSS_REVENUE_CAPSULE, BUSINESS_PROFIT_CAPSULE];
    // changeList.forEach((item: IBusinessGrossRevenueCapsule[]) => {
    //   item.forEach((childItem: IBusinessGrossRevenueCapsule) => {
    //     childItem.metrics = changeCapsualBusinessTeamItem(childItem.metrics, value);
    //   });
    // });

    // Button埋点 - Track checkbox change
    const btnPoint = createBtnPoint(
      ExecutiveSummaryTab,
      'businessTeamForecastCheckbox',
      value.toString(),
    );
    if (btnPoint) {
      SGBuriedBtnPoint(btnPoint);
    }
  };

  return (
    <>
      <div
        className="dbs-segment-row"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Segment
          className="dbs-gradient-segment"
          options={tabList}
          value={activeSegment}
          onChange={handleActiveSegmentChange}
        />
        {activeSegment === 'executiveSummary' && executiveSummaryHasView && (
          <Checkbox.Group
            value={forecastCheckbox}
            onChange={handleForecastCheckboxChange}
            className="dbs-home-business-overview-checkbox"
          >
            {BUSINESS_TEAM_CHECKBOX.map((item) => (
              <Checkbox key={item.value} name={item.value}>
                {formatMessage({ id: item.title })}
              </Checkbox>
            ))}
          </Checkbox.Group>
        )}
      </div>
      {
        tabList.map(item => activeSegment === item.value ? (
          item.hasAuth ?
            <React.Fragment key={item.key}>{item.modules}</React.Fragment> :
            <NoAuthPage key={item.key} admins={item.admins || []} />
        ) : null)
      }
    </>
  );
}
